import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
//import Link from '@mui/material/Link';
import { Link } from 'react-router-dom';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import AuthService from "./../../services/auth-service";
import UserService from "./../../services/user-service";
import { useSelector, useDispatch } from 'react-redux'
import { setUser } from '../../redux/userSlice'

const Login = () => {

    if (AuthService.getCurrentUser()) {
        window.location = "/dashboard";
    }

    const user = useSelector((state) => state)
    const dispatch = useDispatch()

    const Copyright = (props) => {
        return (
            <Typography variant="body2" color="text.secondary" align="center" {...props}>
                {`Copyright ${String.fromCodePoint(0x00A9)} `}
                <Link color="inherit" to="https://sms.mwc.pl/">
                    smsJET.pl
                </Link>{' '}
                {new Date().getFullYear()}
                {'.'}
            </Typography>
        );
    }

    const defaultTheme = createTheme();

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        let result = await AuthService.login(data.get('email'), data.get('password'));
        dispatch(setUser(result.data));
        window.location = "/dashboard";
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Logowanie
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Hasło"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        <Button
                            style={{ background: "#212529" }}
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Zaloguj się
                        </Button>

                        <Grid container className="mt-4">
                            <Grid item xs>
                                <Link className="additional-background-color link-body2" to="/forgot">
                                    Zapomniałeś hasła?
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link className="additional-background-color link-body2"  to="/register">
                                    {"Nie masz konta? Zarejestruj się!"}
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}

export default Login;